import * as types from './vto.types';
import * as constants from './vto.constants';

export const initialVtoPage = (): types.IInitialVtoPage => ({
  type: constants.VTO_MEETING_PAGE,
});
